export const allAdvicesRoute: string = "all-advices";
export const singleAdviceRoute: string = "single-advice";